export default __webpack_public_path__ + "932b816dfba1e85df0ef4da1b4f81bdb.jpg";